import { faker } from '@faker-js/faker'
import { build, perBuild } from '@jackfranklin/test-data-bot'

import type { GetIntegrations, Integration } from '.'

export const integrationBuilder = build<Integration>('integrationBuilder', {
  fields: {
    id: perBuild(() => faker.string.uuid()),
    integrator: {
      id: perBuild(() => faker.string.uuid()),
      name: perBuild(() => faker.company.name()),
      isBackmarketIntegrator: perBuild(() => faker.datatype.boolean()),
    },
    date: perBuild(() => faker.date.past().toISOString()),
    status: {
      code: perBuild(() => faker.string.uuid()),
      label: perBuild(() => faker.string.uuid()),
    },
  },
})

export function getIntegrationsPayloadFactory({
  count = 100,
  pageSize = 10,
} = {}): GetIntegrations {
  return {
    count,
    results: integrationBuilder.many(pageSize),
    next: null,
    previous: null,
  }
}
